import getLocalData from "./getLocalData";

const getRestaurantsLink = () => {
  let href;
  const deliveryDetails = getLocalData("deliveryDetails");
  if (deliveryDetails && deliveryDetails.postalCode && deliveryDetails.city) {
    if (deliveryDetails.adminWard) {
      href = `/restaurants/${deliveryDetails.city}/${
        deliveryDetails.adminWard
      }/?postcode=${
        deliveryDetails.postalCode
      }&time=${deliveryDetails.preOrder || "now"}`;
    } else {
      href = `/restaurants/${deliveryDetails.city}/list/?postcode=${
        deliveryDetails.postalCode
      }&time=${deliveryDetails.preOrder || "now"}`;
    }
  } else {
    href = "/";
  }
  return href;
};

export default getRestaurantsLink;
